import {useContext} from "react";
import PropTypes from 'prop-types';
import {Link as RouterLink} from 'react-router-dom';
import makeStyles from "@material-ui/core/styles/makeStyles";
// @mui
import {styled} from '@mui/material/styles';
import {Box, Link, Typography} from '@mui/material';
// hooks
// routes
// components
import {ProfileContext} from "../../contexts/ProfileContext";
import Avatar from "../../components/Avatar";


// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

// ----------------------------------------------------------------------

NavbarAccount.propTypes = {
  isCollapse: PropTypes.bool,
};

export default function NavbarAccount({ isCollapse }) {
    function stringAvatar(name) {
       // console.log(name);
        return {
            children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
        };
    }
    const useStyles = makeStyles(theme => ({
        sideAvatar:{
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main
        }

    }));
    const classes = useStyles();
  const profileContext = useContext(ProfileContext);
  return (
    <Link underline="none" color="inherit" component={RouterLink} to="/">
      <RootStyle
        sx={{
          ...(isCollapse && {
            bgcolor: 'transparent',
          }),
        }}
      >
          {!profileContext.isLoading &&
          <>
              {profileContext.profile.name !== undefined &&
              <Avatar className={classes.sideAvatar}  {...stringAvatar(profileContext.profile.name)} />
              }
          </>
          }

        <Box
          sx={{
            ml: 2,
            transition: (theme) =>
              theme.transitions.create('width', {
                duration: theme.transitions.duration.shorter,
              }),
            ...(isCollapse && {
              ml: 0,
              width: 0,
            }),
          }}
        >
            <Typography variant="subtitle2" sx={{ color: 'text.primary' }} noWrap>
                {profileContext.profile.name}
            </Typography>
        </Box>
      </RootStyle>
    </Link>
  );
}
